const phoneRegex = /^[+]*[(]{0,1}[0-9]{0,3}[)]{0,1}[-\s/0-9]{8,14}$/

const emailRegex =
  /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/

export { phoneRegex, emailRegex }
